import React from 'react';
import { SidePanelProps, SidePanelTab, SidePanelTabConfig } from '../../../types/DesignSystem/SidePanel';
import Button from '../Button/Button';
import Tab from '../Tab/Tab';
import CompatioLoader from 'Components/Common/components/CompatioLoader';

const TABS: SidePanelTabConfig[] = [
  { id: 'basic', label: 'Basic Info' },
  { id: 'commend', label: 'Commend' },
  { id: 'guide', label: 'Guide' },
];

const SidePanel: React.FC<SidePanelProps> = ({
  isOpen,
  onClose,
  onSave,
  title,
  activeTab,
  onTabChange,
  isLoading = false,
  children
}) => {
  if (!isOpen) {
    return null;
  }

  const handleSave = async () => {
    if (onSave) {
      try {
        await onSave(null);
      } catch (error) {
        console.error('Error saving:', error);
      }
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50 tw-transition-opacity tw-duration-300 tw-z-40"
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Side Panel */}
      <div
        className={`tw-fixed tw-right-0 tw-top-16 tw-bottom-0 tw-w-[416px] tw-bg-white tw-shadow-lg tw-transition-transform tw-duration-300 tw-z-50 tw-flex tw-flex-col ${isOpen ? 'tw-translate-x-0' : 'tw-translate-x-full'
          }`}
      >
        {/* Header */}
        <div className="tw-px-4 tw-py-3">
          <div className="tw-flex tw-items-center tw-gap-2">
            <div className="tw-flex-grow tw-text-grey-900 tw-text-sm tw-font-semibold tw-leading-5">
              {title && typeof title === 'string' ? (
                <>
                  <span className="tw-font-semibold">{title.split(':')[0]}:</span>
                  {title.split(':')[1] && <span className="tw-font-normal">{title.split(':')[1]}</span>}
                </>
              ) : (
                title
              )}
            </div>
            <div className="tw-flex tw-gap-2 tw-shrink-0">
              <Button
                variant="tertiary"
                onClick={onClose}
                disabled={isLoading}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={handleSave}
                disabled={isLoading}
              >
                {isLoading ? 'Saving...' : 'Save'}
              </Button>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <Tab
          tabs={TABS}
          activeTabId={activeTab}
          onChange={(tabId) => onTabChange(tabId as SidePanelTab)}
          className="tw-mt-3"
        />

        {/* Content */}
        {isLoading ? <CompatioLoader /> : <div className="tw-flex-1 tw-overflow-y-auto tw-px-6 tw-py-4">
          {children}
        </div>}
      </div>
    </>
  );
};

export default SidePanel;
